export const DEFAULT_DISPLAY_CONTENT_PUBLICATIONS_CAROUSEL_CONFIG = {
  autoPlay: true,
  intervalSeconds: 6,
}

export const DEFAULT_DISPLAY_CONTENT_VIDEO_PLAYBACK_CONFIG = {
  awayBehavior: "floating" as const,
  countImpressions: true,
  countRepeatPlays: true,
  floatingPopupEnabled: false,
  heartbeatSeconds: 10,
  raffleVideo: {
    autoplay: false,
    controls: true,
    fullscreenEnabled: true,
    frameBackgroundEnabled: false,
    frameBorderEnabled: false,
    frameBorderRadius: 0,
    loop: false,
    muted: false,
    objectFit: "contain" as const,
    showWinViewCount: true,
    winViewCountPlacement: "outsideBelow" as const,
  },
  viewThresholdSeconds: 5,
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value)

export const mergeDisplayContentConfigDefaults = <Config extends Record<string, unknown>>(
  configurationData: unknown,
  defaultConfiguration: Config,
): Config => {
  const source = isRecord(configurationData) ? configurationData : {}
  const defaultVideoPlayback = isRecord(defaultConfiguration.videoPlayback)
    ? defaultConfiguration.videoPlayback
    : {}
  const sourceVideoPlayback = isRecord(source.videoPlayback) ? source.videoPlayback : {}
  const defaultRaffleVideo = isRecord(defaultVideoPlayback.raffleVideo)
    ? defaultVideoPlayback.raffleVideo
    : {}
  const sourceRaffleVideo = isRecord(sourceVideoPlayback.raffleVideo)
    ? sourceVideoPlayback.raffleVideo
    : {}

  return {
    ...defaultConfiguration,
    ...source,
    rafflesScreen: {
      ...(isRecord(defaultConfiguration.rafflesScreen) ? defaultConfiguration.rafflesScreen : {}),
      ...(isRecord(source.rafflesScreen) ? source.rafflesScreen : {}),
    },
    publicationsCarousel: {
      ...(isRecord(defaultConfiguration.publicationsCarousel)
        ? defaultConfiguration.publicationsCarousel
        : {}),
      ...(isRecord(source.publicationsCarousel) ? source.publicationsCarousel : {}),
    },
    videoPlayback: {
      ...defaultVideoPlayback,
      ...sourceVideoPlayback,
      raffleVideo: {
        ...defaultRaffleVideo,
        ...sourceRaffleVideo,
      },
    },
  } as Config
}
